import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaCheckCircle, FaEnvelope } from 'react-icons/fa';

const RegistrationSuccess = () => {
    const [message, setMessage] = useState(
        'Benutzer erfolgreich registriert. Bitte überprüfen Sie Ihre E-Mails, um Ihre E-Mail-Adresse zu bestätigen.'
    );

    // Log when this component is rendered and get any stored message
    useEffect(() => {
        console.log('RegistrationSuccess component rendered');

        // Get any custom success message
        const successMessage = sessionStorage.getItem('registrationSuccessMessage');
        if (successMessage) {
            setMessage(successMessage);
            // Optional: clear it after using
            // sessionStorage.removeItem('registrationSuccessMessage');
        }
    }, []);

    return (
        <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <motion.div
                className="max-w-md w-full space-y-6 bg-white p-8 rounded-xl shadow-lg"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
            >
                <div className="flex flex-col items-start justify-start">
                    <img
                        src="/images/logo/leadersoft-client-plattform.svg"
                        alt="Bernie Logo"
                        className="h-8 mb-2"
                    />
                </div>

                <div className="text-center">
                    <FaCheckCircle className="mx-auto h-12 w-12 text-green-500" />
                    <h2 className="mt-4 text-xl font-semibold text-gray-900">Registrierung erfolgreich!</h2>

                    <div className="mt-4 text-gray-700">
                        <p className="mb-2">{message}</p>
                        <p className="mb-4">Die Bestätigungs-E-Mail könnte sich in Ihrem Posteingang oder Spam-Ordner befinden.</p>

                        <div className="mt-6 flex flex-col items-center">
                            <FaEnvelope className="text-blue-500 h-6 w-6 mb-2" />
                            <p className="text-sm text-gray-600">Keine E-Mail erhalten?</p>
                            <Link to="/resend-verification" className="text-blue-600 hover:text-blue-800 font-medium mt-2">
                                Bestätigungs-E-Mail erneut senden
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="mt-6 pt-4 border-t border-gray-200 text-center">
                    <Link to="/login" className="text-blue-600 hover:text-blue-800 font-medium">
                        Zurück zur Anmeldeseite
                    </Link>
                </div>
            </motion.div>
        </div>
    );
};

export default RegistrationSuccess;
